export enum StationTabType {
  ALL_STATIONS = 'allStations',
  SELECTED = 'selected',
}

export interface StationSelectedContextValue {
  activeTab: StationTabType;
  setActiveTab: (tab: StationTabType) => void;
}
